module.exports = __webpack_public_path__ + "media/images/flags/ZM-4de93d1f659669cb17f634b1187d485f.svg";